import React, {useEffect, useState} from "react";
import {useTranslation} from 'react-i18next';

import {Alert, Button, Col, Form, Row} from "react-bootstrap";
import BtnSliderRoundedComponent from "../switch/BtnSliderRoundedComponent";
import {conditionalSuccess, determineDefault, isValid} from "./FormUtils";
import {Actions} from "../../../client/Actions";
import ModalForm from "./ModalForm";
import FormInputFile from "../file/FormInputFile";
import renderUtils from "../../helpers/renderUtils";
import 'react-bootstrap-typeahead/css/Typeahead.css';
import {Typeahead} from "react-bootstrap-typeahead";
import Select from "react-select";
import XButton from "../button/XButton";
import {isObject} from "formik";
import NumberFormat from "react-number-format";
import {CustomSelect} from "./CustomSelect";
import tab from "bootstrap/js/src/tab";
import CardTable from "../table/CardTable";


const FormGenerator = ({
                           fields,
                           initialData,
                           formData,
                           setFormData,
                           setReady,
                           initData,
                           readOnly,
                           alertInvalid,
                           localDictionaries,
                           reload,
                           alertData,
                           additionalDataForFilters,
                           hideIfNull,
                           onRemoveField,
                           setLoader,
                           onSubmit
                       }) => {

        const {t} = useTranslation();
        const [dictionaries, setDictionaries] = useState({});
        const loaded = {};
        const tempState = {};

        const [validation, setValidation] = useState([]);
        const [showMeasurement, setShowMeasurement] = useState({});
        const [creationModals, setCreationModals] = useState({});
        const [tableChecked, setTableChecked] = useState();
        const [dictionaryDetailsExpanded, setDictionaryDetailsExpanded] = useState({});

        const booleanOptions = [{id: true, name: t("common.yes")}, {id: false, name: t("common.no")}];


        function loadDictionaries() {
            Object.keys(loaded).forEach(key => loaded[key] === false);

            fields.fields.forEach((field) => {

                const {type, readOnlyValue} = field;

                if (readOnly !== true || readOnlyValue) {


                    if (type === "dictionary") {
                        const {dictionary, dictionaryApi} = field;
                        loaded[dictionary] = false;
                        if (localDictionaries && localDictionaries[dictionary]) {
                            const callback = getUpdateDictionaryFunction(dictionary)
                            callback(localDictionaries[dictionary])
                        } else {
                            Actions.get(dictionaryApi ? dictionaryApi : dictionary, getUpdateDictionaryFunction(dictionary));
                        }
                    }

                    if (type === "enum") {
                        const {enumType} = field;
                        loaded[enumType] = false;

                        if (localDictionaries && localDictionaries[enumType]) {
                            const callback = getUpdateDictionaryFunction(enumType)
                            callback(localDictionaries[enumType])
                        } else {
                            Actions.get(enumType ? enumType : enumType, getUpdateDictionaryFunction(enumType));
                        }


                    }
                }
            });

        }


        const getUpdateDictionaryFunction = (dictionary) => {
            return (response) => updateDictionary(dictionary, response);
        };

        const updateDictionary = (dictionary, data) => {
            data.filter(entry => isObject(entry)).forEach(item => item.labelKey = Object.keys(item).map(key => item[key] || "").join(" "))
            tempState[dictionary] = data;
            loaded[dictionary] = true;
            if (!Object.keys(loaded).find(key => loaded[key] === false)) {
                setDictionaries(tempState);

                Object.keys(tempState).forEach(key => {

                    if (tempState[key] && Array.isArray(tempState[key]) && tempState[key].find(v => v.defaultValue || v.defaultValue === "true")) {
                        let defaultValue = tempState[key].find(v => v.defaultValue || v.defaultValue === "true");
                        handleFieldChange(key, defaultValue);
                    }
                });
            }


        };

        function reloadData() {
            loadDictionaries();
        }

        function formAction() {
            console.log(formData);
            if (formData && readOnly !== true) {
                validate();
                console.log(formData);
            } else if (initData !== false) {
                initFormData();
            }
        }


        function validate() {
            let validationResult = [];
            let allValid = true;
            fields.fields
                .filter(f => f.type !== "unvisible")
                .filter(f => f.type !== "staticImage".toLowerCase())
                .filter(f => f.type !== "component")
                .filter(f => f.onlyForReadOnly !== true)
                .forEach((field) => {
                    let valid = isValid(field, formData);


                    validationResult[field.name] = valid;
                    if (!valid) {
                        allValid = false;
                    }
                });


            setValidation(validationResult);


            console.log(allValid);
            console.log(validationResult);
            setReady(allValid);
        }


        function initFormData() {

            if (!formData) {

                const result = {};
                console.log("fields " + fields)
                fields.fields
                    .filter(f => readOnly ? true : f.onlyForReadOnly !== true)
                    .forEach((field) => {
                        result[field.name] = determineDefault(field, initialData, dictionaries);
                    });
                setFormData(result);
            }
        }

        function initChecked() {
            const tableField = fields.fields.find(f => f.type === "table");

            if (tableField && !tableChecked && formData) {

                setTableChecked(formData[tableField.name])
            }
        }

        function handleTableCheckedChanged() {
            const tableField = fields.fields.find(f => f.type === "table");

            if (tableField && tableChecked && formData) {

                handleMultipleFieldsChange(tableField.name, tableChecked)
            }
        }


        useEffect(formAction, [formData, readOnly]);
        useEffect(reloadData, [reload, localDictionaries]);
        useEffect(loadDictionaries, [readOnly]);
        useEffect(initChecked, [formData]);
        useEffect(handleTableCheckedChanged, [tableChecked]);


        const handleFieldChange = (fieldName, value) => {
            setFormData({
                ...formData,
                [fieldName]: value
            });
        };

        const handleModalChange = (fieldName, value) => {
            setCreationModals({
                ...creationModals,
                [fieldName]: value
            });
        };


        const collapseDictionary = (fieldName) => {
            setDictionaryDetailsExpanded({
                ...dictionaryDetailsExpanded,
                [fieldName]: !dictionaryDetailsExpanded[fieldName]
            });
        };

        function fetchValueFromDictionary(triggerValue, triggerField) {
            if (triggerValue) {
                let triggerFieldDef = fields.fields.find(f => f.name === triggerField);
                if (triggerFieldDef && triggerFieldDef.type === "dictionary" && dictionaries[triggerFieldDef.dictionary]) {
                    triggerValue = dictionaries[triggerFieldDef.dictionary].find(d => d.id == triggerValue.id);
                }
            }
            return triggerValue;
        }

        function fillFieldsToUpdate(field, updated, result) {
            const filtered = fields.fields
                .filter(f => !updated.includes(f.name)
                    && f.autoComplete
                    && f.autoComplete.triggers
                    && f.autoComplete.triggers.includes(field)
                );


            filtered.forEach(f => {
                const index = f.autoComplete.triggers.indexOf(field);
                let calculated;


                if (f.autoComplete.triggers.length === 1) {
                    const triggerField = f.autoComplete.triggers[0];


                    let triggerValue = result[triggerField] ? result[triggerField] : formData[triggerField];
                    triggerValue = fetchValueFromDictionary(triggerValue, triggerField);

                    console.log(triggerValue);
                    calculated = f.autoComplete.calculation(triggerValue);
                } else if (index === 0) {
                    const secondField = f.autoComplete.triggers[1];
                    const secondValue = result[secondField] ? result[secondField] : formData[secondField];
                    calculated = f.autoComplete.calculation(result[field], secondValue);
                } else {
                    const firstField = f.autoComplete.triggers[0];
                    const firstValue = result[firstField] ? result[firstField] : formData[firstField];
                    calculated = f.autoComplete.calculation(firstValue, result[field]);
                }
                result[f.name] = calculated;

                updated.push(f.name);
            });

            filtered.forEach(f => {
                fillFieldsToUpdate(f.name, updated, result);
            });

            if (result[field] === "false") {
                const conditional = fields.fields
                    .filter(f => !updated.includes(f.name)
                        && f.conditionalOn
                        && f.conditionalOn === field
                    );

                conditional.forEach(f => {
                    result[f.name] = determineDefault(f, initialData, dictionaries);

                    updated.push(f.name);
                });
            }


            const clearAfterChange = fields.fields
                .filter(f => !updated.includes(f.name)
                    && f.clearAfterChange === field
                );

            clearAfterChange.forEach(f => {
                result[f.name] = determineDefault(f, initialData, dictionaries);

                updated.push(f.name);
            });


        }

        const handleMultipleFieldsChange = (fieldName, value) => {
            const updateFileds = [fieldName];
            const result = {[fieldName]: value};
            fillFieldsToUpdate(fieldName, updateFileds, result);

            setFormData({
                ...formData,
                ...result
            });
        };

        function defineClass(field) {
            if (readOnly || field.readOnly) {
                return "";
            }
            // return validation[field.name] ? "is-valid" : "is-invalid";
            return validation[field.name] ? "" : "is-invalid";
        }

        function textField(field, value) {
            const val = value || formData[field.name]

            if (hideIfNull && (val === "" || !val)) {
                return ""
            }

            return (
                <>
                    {
                        field.alert && field.alert.condition(value || formData[field.name], alertData) &&
                        <Alert variant="danger"><i
                            className="fas fa-info-circle mr-1"></i><strong> {field.alert.title}</strong></Alert>
                    }
                    <Form.Group>


                        <Form.Label><strong>{field.label}</strong></Form.Label>
                        <Row>
                            <Col md={field.removable ? 9 : 12}>
                                {field.type !== "number" && <>
                                    <Form.Control
                                        maxLength
                                        as={field.type === "textarea" ? field.type : "input"}
                                        className={defineClass(field)}
                                        disabled={field.readOnly || readOnly}
                                        id={field.name}

                                        onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (field.type === "decimal" && newValue !== "") {
                                                newValue = parseFloat(parseFloat(newValue).toFixed(2));
                                            }

                                            if (field.format && newValue !== "") {
                                                newValue = field.format(newValue);
                                            }

                                            if (field.capsLock && newValue !== "") {
                                                newValue = newValue.toUpperCase();
                                            }

                                            if (field.type === "number" && newValue !== "") {
                                                if (field.integer) {
                                                    const regex = /^\d+$/;
                                                    if (!regex.test(newValue)) {
                                                        return;
                                                    }
                                                } else if (field.scale) {
                                                    const regex = new RegExp("^\\d+(\\.\\d{0," + field.scale + "})?$");
                                                    if (!regex.test(newValue)) {
                                                        // If the value does not match the pattern, return or handle the error
                                                        return;
                                                    }
                                                } else if (!/^[^\D_]+$/.test(newValue)) {
                                                    return;
                                                }


                                            }

                                            if (field.maxLength && newValue && newValue.length > field.maxLength) {
                                                return;
                                            }


                                            handleMultipleFieldsChange(field.name, newValue);

                                        }}
                                        name={field.name}
                                        value={value || formData[field.name]}
                                        type="text"
                                        placeholder={field.placeholder}
                                    />
                                    {field.maxLength ?
                                        <>
                                            {field.maxLength > 0 ?
                                                <Form.Text className="text-muted">
                                                    {(value || formData[field.name])?.length || 0}/{field.maxLength} symbols
                                                </Form.Text> :
                                                <Form.Text className="text-muted">
                                                    {t("forms.reached_maximum_characters")}
                                                </Form.Text>}
                                        </> : ""
                                    }
                                </>
                                }
                                {field.type === "number" &&
                                    <NumberFormat
                                        id={field.name}
                                        disabled={field.readOnly || readOnly}
                                        className={"form-control " + defineClass(field)}
                                        name={field.name}
                                        value={value ?? formData[field.name] ?? ""}
                                        placeholder={field.placeholder}
                                        allowNegative={false}
                                        allowLeadingZeros={false}
                                        thousandSeparator=" "
                                        // Enforce integer/scale directly:
                                        decimalScale={field.integer ? 0 : (typeof field.scale === "number" ? field.scale : undefined)}
                                        fixedDecimalScale={false}
                                        // Extra guard (optional): only allow digits or digits with dot up to scale
                                        isAllowed={({value}) => {
                                            if (value === "") return true;
                                            if (field.integer) return /^\d+$/.test(value);
                                            if (typeof field.scale === "number") {
                                                const re = new RegExp("^\\d+(\\.\\d{0," + field.scale + "})?$");
                                                return re.test(value);
                                            }
                                            return /^\d+(\.\d+)?$/.test(value);
                                        }}
                                        // Give your state the *raw numeric string* without separators
                                        onValueChange={({value}) => {
                                            // Optionally trim to maxLength of raw value for numbers
                                            if (field.maxLength && value && value.length > field.maxLength) return;
                                            handleMultipleFieldsChange(field.name, value);
                                        }}
                                    />
                                }
                            </Col>
                            {field.removable &&
                                <Col md={3} className={"ml-0 pl-0"}>
                                    <XButton
                                        tooltip={field.removableTooltip}
                                        onClick={() => onRemoveField(field)}
                                    />
                                </Col>
                            }
                        </Row>


                    </Form.Group>
                </>
            );


        }

        function measurement(field) {

            function updateShowMeasurement(val) {
                setShowMeasurement({
                    ...showMeasurement,
                    [field.name]: val
                })
            }

            return (
                <>


                    <Form.Group>
                        <Form.Label><strong>{field.label}</strong></Form.Label>
                        <Row>
                            <Col md={readOnly ? 12 : 8}>
                                <Form.Control
                                    as={"input"}
                                    disabled={true}
                                    id={field.name}
                                    onChange={(event) => {
                                        let newValue = event.target.value;

                                        const regex = new RegExp("^\\d+(\\.\\d{0," + 2 + "})?$");
                                        if (!regex.test(newValue)) {
                                            return undefined;
                                        }

                                        if (field.filterTargetValue) {
                                            newValue = field.filterTargetValue(field);
                                        }


                                        handleMultipleFieldsChange(field.name, newValue);
                                    }}
                                    name={field.name}
                                    value={formData[field.name]}
                                    type="text"
                                    placeholder={field.placeholder}
                                />
                            </Col>
                            {!readOnly &&
                                <Col md={4}>
                                    <Button
                                        onClick={() => updateShowMeasurement(true)}
                                        variant={"outline-primary float-center"}>{t("forms.measurement")}</Button>
                                </Col>
                            }
                        </Row>

                    </Form.Group>
                </>
            );


        }

        function datePicker(field) {


            return (
                <>
                    <Form.Group>
                        <Form.Label><strong>{field.label}</strong></Form.Label>
                        <Form.Control
                            className={defineClass(field)}
                            disabled={readOnly}
                            id={field.name}

                            onChange={(event) => {
                                let newValue = event.target.value;
                                handleFieldChange(field.name, newValue);
                            }}
                            name={field.name}
                            value={formData[field.name]}
                            type="date"
                        />
                    </Form.Group>
                </>
            );


        }

        function file(field) {


            return (
                <>
                    <FormInputFile
                        titleText={field.label}
                        labelText={t("forms.choose_file")}
                        idName={field.name}
                        path={"file"}
                        requestParameterName={"file"}
                        setImagesParentStore={(files) => handleFieldChange(field.name, files)}
                        imagesParentStore={formData[field.name]}
                        disabled={readOnly}
                    />
                </>
            );


        }


        function boolean(field) {

            if (readOnly) {

                const bool = booleanOptions.find(v => v.id === formData[field.name]);
                const value = bool ? bool.name : "";

                return textField(field, value);
            }

            return (
                <>

                    <Form.Group>
                        <Form.Label><strong>{field.label}</strong></Form.Label>
                        <Form.Control as="select" name={field.name}
                                      if={field.name}
                                      value={formData[field.name]}
                                      disabled={readOnly || field.readOnly}
                                      className={defineClass(field)}
                                      onChange={(event) => {
                                          let newValue = event.target.value;

                                          handleMultipleFieldsChange(field.name, newValue);

                                      }}>
                            <option value="" disabled={!field.defaultEnabled}>{t("forms.choose")}</option>
                            {
                                booleanOptions.map((el => {
                                    return <option key={el.id} value={el.id}>{el.name}</option>;
                                }))
                            }
                        </Form.Control>
                    </Form.Group>

                </>
            );


        }


        function renderDictionaryName(field, dictionaryValue) {
            return field.render ? field.render(dictionaryValue) : dictionaryValue.name;
        }

        function dictionary(field) {
            const {dictionaryApi, dictionary, groupedDictionary} = field;
            let values = dictionaries[dictionary] || [];


            if (readOnly) {

                const dictionaryValue = formData[field.name];
                let value = dictionaryValue ? renderDictionaryName(field, dictionaryValue) : "";
                if (!value || value === "") {
                    if (field.readOnlyValue) {
                        value = field.readOnlyValue(values);
                    }
                }
                return textField(field, value ? value : "");
            }

            if (field.filterValues) {
                values = field.filterValues(dictionaries, formData, values, additionalDataForFilters);
            }

            const selectOptions = fields.useSelect ? values.map(v => {
                return {value: v, label: field.renderOption(v)}
            }) : []

            console.log(values)

            return <>
                <Form.Group>
                    <Form.Label><strong>{field.label}</strong></Form.Label>
                    {field.creationForm ?
                        <div className="text-secondary" id={"open-modal" + field.name}
                             onClick={() => handleModalChange(field.name, true)}>
                            <i className="fas fa-plus-circle" style={{marginLeft: "5px", fontSize: "15px"}}/>
                        </div> : ""}
                    {field.withAutocomplete &&

                        <Typeahead
                            name={field.name}
                            id={field.name}
                            labelKey={field.labelKey || "presentableName"}
                            disabled={readOnly || field.readOnly}
                            options={values}
                            filterBy={field.filterBy}
                            placeholder={field.placeholder}
                            // selected={formData[field.name] ? formData[field.name] : null}
                            className={defineClass(field)}
                            renderMenuItemChildren={(option) => (
                                <div>
                                    {field.renderOption ? field.renderOption(option) : option.id + ""}
                                </div>
                            )}
                            onChange={(value) =>
                                handleMultipleFieldsChange(field.name, value[0])
                            }
                        />
                    }
                    {field.useSelect &&
                        <>
                            <CustomSelect
                                value={selectOptions.find(o => o.value.id === formData[field.name]?.id)}
                                onChange={(selectedOption) =>
                                    handleMultipleFieldsChange(field.name, selectedOption.value)
                                }
                                classNamePrefix={defineClass(field) + " " + field.className}
                                placeholder={field.placeholder || t("forms.choose")}
                                searchBy={field.searchBy}
                                options={values.map(v => {
                                    return {
                                        value: v,
                                        isDisabled: field.optionDisabled ? field.optionDisabled(v) : false,
                                        label: field.renderOption(v)
                                    }
                                })}
                            />
                        </>
                    }
                    {!field.withAutocomplete && !field.useSelect && <Form.Control as="select"
                                                                                  name={field.name}
                                                                                  id={field.name}
                                                                                  disabled={readOnly || field.readOnly}
                                                                                  value={formData[field.name] ? formData[field.name].id : ""}
                                                                                  className={defineClass(field)}
                                                                                  onChange={(event) => {
                                                                                      if (field.selectObject) {
                                                                                          handleMultipleFieldsChange(field.name, values.find(v => v.id === parseInt(event.target.value)))

                                                                                      } else {
                                                                                          handleMultipleFieldsChange(field.name, {id: parseInt(event.target.value)})
                                                                                      }
                                                                                  }}>
                        <option value="" disabled>{t("forms.choose")}</option>
                        {
                            groupedDictionary ?
                                Object.keys(values).map((item, i) => (
                                    <>
                                        <optgroup key={item + i} label={item}>
                                            {
                                                values[item].map((item, index) => {
                                                    return <option key={item.id}
                                                                   value={item.id}>{item.name}</option>
                                                })
                                            }
                                        </optgroup>
                                    </>
                                ))
                                :
                                values.map((val => {
                                    return <option key={val.id}
                                                   value={val.id}>{renderDictionaryName(field, val)}</option>;
                                }))
                        }
                    </Form.Control>
                    }
                </Form.Group>

                {field.creationForm ?
                    <ModalForm
                        setLoader={() => {
                        }}
                        api={dictionaryApi ? dictionaryApi : dictionary}
                        title={field.modalTitle ? field.modalTitle : t("forms.new") + " " + field.label}
                        open={creationModals[field.name]}
                        setOpen={(value) => handleModalChange(field.name, value)}
                        fields={field.creationForm}
                        onFinish={reloadData}

                    />
                    : ""}

            </>;
        }

        function multipleEnumType(field, values, enumType) {
            return <Form.Group>
                <Form.Label><strong>{field.label}</strong></Form.Label>
                <Select
                    value={formData[field.name] ? formData[field.name].id : ""}
                    onChange={(selectedOption) =>
                        handleFieldChange(field.name,
                            selectedOption.length > 0 ? selectedOption.map(sv => sv.value) : undefined
                        )
                    }
                    classNamePrefix={defineClass(field)}
                    isMulti
                    placeholder={t("forms.choose")}
                    options={values.map(v => {
                        return {value: v, label: renderUtils.renderEnumName(v, enumType, t)}
                    })}
                />
            </Form.Group>;
        }


        function staticImage(field) {
            return (
                <div>
                    {field.label &&
                        <Form.Label><strong>{field.label}</strong></Form.Label>
                    }
                    <img className={"mt-2"} src={`/assets/img/${field.fileName}`} alt={field.label}
                         style={{maxWidth: "100%"}}/>
                </div>
            );
        }


        function enumType(field) {
            const {enumType} = field;
            let values = dictionaries[enumType] || [];

            if (field.filterValues) {
                values = field.filterValues(dictionaries, formData, values, additionalDataForFilters);
            }

            if (readOnly) {

                const enumValue = formData[field.name];
                if (field.multiple) {
                    const value = enumValue && Array.isArray(enumValue) ? enumValue.map(v => renderUtils.renderEnumName(v, enumType, t)).join(", ") : "";
                    return textField(field, value ? value : "");
                }

                const value = enumValue ? renderUtils.renderEnumName(enumValue, enumType, t) : "";
                return textField(field, value ? value : "");
            }

            if (field.multiple) {
                return multipleEnumType(field, values, enumType)
            }


            return <>
                <Form.Group>
                    <Form.Label><strong>{field.label}</strong></Form.Label>
                    <Form.Control as="select"
                                  name={field.name}
                                  id={field.name}
                                  disabled={field.readOnly || readOnly}
                                  value={formData[field.name] ? formData[field.name] : ""}
                                  className={defineClass(field)}
                                  onChange={(event) =>
                                      handleFieldChange(field.name, event.target.value)
                                  }>
                        <option value="" disabled>{t("forms.choose")}</option>
                        {
                            values.map((value => {
                                return <option key={value}
                                               value={value}>{renderUtils.renderEnumName(value, enumType, t)}</option>;
                            }))
                        }
                    </Form.Control>
                </Form.Group>
            </>;
        }

        function dictionaryDetails(field) {
            const value = formData[field.name];
            const keys = value ? Object.keys(value) : [];


            return <>
                <Form.Group>


                    <Form.Label><strong>{field.label}</strong></Form.Label>

                    <Form.Row>
                        <Col className="d-flex">
                            <Form.Control
                                name={field.name + "-name"}
                                value={value ? value.name : ""}
                                readOnly={true}
                                type="text"
                                placeholder=""
                            />
                            {keys.length > 2 ?
                                <Button variant="outline-primary" onClick={() => collapseDictionary(field.name)}
                                        id={"collapse-" + field.name} data-toggle="collapse" role="button"
                                        className="collapsed"
                                        type="button" data-target={"#collapse-" + field.name} aria-expanded="false">
                                    <i className="fas fa-chevron-down"/>
                                </Button>
                                : ""
                            }
                        </Col>
                    </Form.Row>


                </Form.Group>


            </>;
        }


        function radioButton(field) {
            return <>
                <Row className={"justify-content-center"}>
                    <Col md={"5"}>
                        <strong className={"p-2"}>{field.label}</strong>

                    </Col>
                    <Col md={"3"}>
                        <BtnSliderRoundedComponent checked={formData[field.name]}
                                                   setState={() => handleFieldChange(field.name, !formData[field.name])}
                                                   disabled={readOnly} red={false}/>
                    </Col>

                </Row>
            </>;
        }

        function checkbox(field) {
            return <>
                <div className={"d-flex"}>
                    <strong>{field.label}</strong>

                    <div id={"checkbox-" + field.name} className="">
                        <label className="checkbox-container">
                            <input type="checkbox" onChange={() => handleFieldChange(field.name, !formData[field.name])}/>
                            <span className="checkmark"></span>
                        </label>
                    </div>


                </div>
            </>;
        }


        function determineField(field) {
            field.type = field.type ? field.type.toLowerCase() : field.type;

            if (field.type === "dictionary") {
                return dictionary(field);
            }
            if (field.type === "measurement") {
                return measurement(field);
            }

            if (field.type === "enum") {
                return enumType(field);

            }
            if (field.type === "staticImage".toLowerCase()) {
                return staticImage(field);

            }

            if (field.type === "component") {
                return generateComponent(field);

            }

            if (field.type === "date") {
                return datePicker(field);

            }

            if (field.type === "file") {
                return file(field);

            }

            if (field.type === "radio") {
                return radioButton(field);

            }

            if (field.type === "boolean") {
                return boolean(field);

            }
            if (field.type === "checkbox") {
                return checkbox(field);

            }

            return textField(field);
        }

        function generateComponent(componentField) {
            if (!componentField.name) {
                return "Define component name!"
            }

            const columns = componentField.config && componentField.config.columns ? componentField.config.columns : 1;

            const blocks = [];

            // eslint-disable-next-line no-plusplus
            for (let i = 1; i <= columns; i++) {
                blocks.push(i);
            }

            return <>

                {blocks.length > 1 ?
                    <Row>{
                        blocks.map(i => {
                            return <Col xs={12} sm={blocks.length > 1 ? 6 : 12} md={12 / blocks.length}>
                                {generateColumn(i, componentField.name)}
                            </Col>;
                        })}
                    </Row>
                    :
                    <>
                        {generateColumn(1, componentField.name)}
                    </>
                }
            </>;
        }


        const checkColumn = {
            label: t("common.selected"),
            field: "checked",
            sort: "desc",
            type: "checkbox",
            width: 200,
            hideForReadonly: true,
        }


        function generateForm() {
            const columns = fields.config && fields.config.columns ? fields.config.columns : 1;

            const blocks = [];
            const tableField = fields.fields.find(f => f.type === "table");

            // eslint-disable-next-line no-plusplus
            for (let i = 1; i <= columns; i++) {
                blocks.push(i);
            }

            return <Form noValidate
                         onSubmit={onSubmit ? onSubmit : () => {
                         }}
                         className={alertInvalid ? "form-invalid-animation" : ""}>

                {blocks.length > 1 ?
                    <Row>{
                        blocks.map(i => {
                            return <Col xs={12} sm={blocks.length > 1 ? 6 : 12} md={12 / blocks.length}>
                                {generateColumn(i)}
                            </Col>;
                        })}
                    </Row>
                    :
                    <>
                        {generateColumn(1)}
                    </>
                }
                {
                    tableField && tableChecked && (tableField.conditionalOn ? conditionalSuccess(tableField, formData) : true) &&
                    <Row>
                        <CardTable
                            initData={tableField.tableConfig.data ? tableField.tableConfig.data(formData) : undefined}
                            source={tableField.tableConfig.api}
                            setLoader={setLoader}
                            title={`${tableField.label} (${tableChecked?.length})`}
                            checked={tableChecked}
                            setChecked={setTableChecked}
                            columns={[checkColumn].concat(tableField.tableConfig.columns)}
                        />
                    </Row>
                }


            </Form>;
        }

        function generateColumn(i, componentName) {

            return fields.fields
                .filter(f => f.column === i || !f.column && i === 1)
                .map((field) => {

                        if (componentName ? componentName !== field.component : field.component) {
                            return;
                        }

                        let show = field.type !== "unvisible" && field.type !== "table" && (readOnly === true ? field.hideForReadOnly !== true : field.onlyForReadOnly !== true);


                        if (field.conditionalOn && field.type !== "table") {

                            show = conditionalSuccess(field, formData);
                        }

                        if (show) {
                            return determineField(field);
                        }
                    }
                );
        }


        return (
            <>

                {formData ? generateForm() : "No form data"}


            </>
        );
    }
;

export default FormGenerator;